import { PlayerUiConfig } from '../types';

const AUDIO_UI_CONFIG: PlayerUiConfig = {
  skin: 'audio',
  colour: '#b80000',
  foreColour: '#222222',
  baseColour: '#222222',
  colourOnBaseColour: '#ffffff',
  fallbackBackgroundColour: '#ffffff',
  controls: { enabled: true, volumeSlider: true },
};

export default AUDIO_UI_CONFIG;
